/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createWebhusetOrderApiFeaturesCatalogInvoiceFeeGetResponseFromDiscriminatorValue, type WebhusetOrderApiFeaturesCatalogInvoiceFeeGetResponse } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /catalog/invoice-fee
 */
export interface InvoiceFeeRequestBuilder extends BaseRequestBuilder<InvoiceFeeRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<WebhusetOrderApiFeaturesCatalogInvoiceFeeGetResponse>}
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<WebhusetOrderApiFeaturesCatalogInvoiceFeeGetResponse | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const InvoiceFeeRequestBuilderUriTemplate = "{+baseurl}/catalog/invoice-fee";
/**
 * Metadata for all the requests in the request builder.
 */
export const InvoiceFeeRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: InvoiceFeeRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        adapterMethodName: "send",
        responseBodyFactory:  createWebhusetOrderApiFeaturesCatalogInvoiceFeeGetResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
